import { useNavigate } from 'react-router-dom';
import { Lock, ArrowRight } from 'lucide-react';
import { useSubscription } from '@/features/subscription/hooks/useSubscription';
import { useLanguage } from '@/shared/contexts/LanguageContext';

interface PlanGateProps {
  children: React.ReactNode;
  title: Record<'fr' | 'en' | 'es', string>;
  description: Record<'fr' | 'en' | 'es', string>;
}

const labels = {
  cta: { fr: 'Voir les plans', en: 'View plans', es: 'Ver planes' },
  starterNote: {
    fr: 'Disponible dès le plan Solo — 19€/mois',
    en: 'Available from the Solo plan — €19/month',
    es: 'Disponible desde el plan Solo — 19€/mes',
  },
};

export function PlanGate({ children, title, description }: PlanGateProps) {
  const { tier, loading, isInTrial } = useSubscription();
  const { language } = useLanguage();
  const navigate = useNavigate();

  if (loading) return null;
  if (tier !== 'free' || isInTrial) return <>{children}</>;

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-6 text-center space-y-6">
      <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center">
        <Lock size={28} className="text-primary" />
      </div>

      <div className="space-y-2 max-w-xs">
        <h2 className="text-xl font-bold font-display">{title[language]}</h2>
        <p className="text-sm text-muted-foreground leading-relaxed">{description[language]}</p>
      </div>

      <p className="text-xs text-primary font-medium">{labels.starterNote[language]}</p>

      <button
        onClick={() => navigate('/pricing')}
        className="flex items-center gap-2 px-6 py-3 bg-primary text-primary-foreground rounded-xl font-semibold text-sm hover:bg-primary/90 transition-colors"
      >
        {labels.cta[language]}
        <ArrowRight size={16} />
      </button>
    </div>
  );
}
